import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=79a627ae&"
import script from "./DocumentModal.vue?vue&type=script&lang=js&"
export * from "./DocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a627ae')) {
      api.createRecord('79a627ae', component.options)
    } else {
      api.reload('79a627ae', component.options)
    }
    module.hot.accept("./DocumentModal.vue?vue&type=template&id=79a627ae&", function () {
      api.rerender('79a627ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DocumentModal.vue"
export default component.exports